import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class ShipmentService {
    constructor(private datatask: DataTaskService) {}

    public load(): Promise<ShipmentOptions> {
        return this.datatask.Post(2316, {});
    }

    public async getShipment(shipmentcontainer_keyno: ShipmentKey): Promise<ShipmentGet | undefined> {
        const shipments: ShipmentGet[] = await this.datatask.Post(2307, { shipmentcontainer_keyno });
        return shipments?.[0];
    }

    public searchKeyname(searchtext: string): Promise<ShipmentSelection[]> {
        return this.datatask.Post(2297, { searchtext });
    }

    public save(page: ShipmentGet): Promise<ShipmentSaveResult> {
        return this.datatask.Post(2315, page);
    }
}

export type ShipmentKey = string | number;
export interface ShipmentSelection {
    shipmentcontainer_keyno: ShipmentKey;
    shipmentcontainer_name?: string;
    shipmentcontainer_keyname?: string;
}
export interface ShipmentGet extends ShipmentSelection, Record<string, unknown> {
    shipmentcontainerstatus_name?: string;
    stockplace_id_from?: string;
    stockplace_id_to?: string;
    prodplace_id?: string;
    reg_by_userid?: string;
    reg_datetime?: string;
    mod_by_userid?: string;
    mod_datetime?: string;
    container?: string;
    container_id?: string;
    date_of_delivery?: string;
    date_of_delivery_est?: string;
    date_of_arrival?: string;
    date_of_arrival_est?: string;
    mrn?: string;
    freight_ex_eu?: string | number;
    edistatus?: string;
    edistatus_return?: string;
    pod_keyno?: string | number;
}
export interface ShipmentOptions {
    prodplaces: { prodplace_id: string; prodplace_name: string }[];
    stockplaces: { stockplace_id: string; stockplace_name: string }[];
    pods: { pod_keyno: string | number; pod_name: string }[];
}
export interface ShipmentSaveResult { shipmentcontainer_keyno: ShipmentKey; }
